import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReloadPlanDataService {
  private reloadPlanDataSubject = new BehaviorSubject<boolean>(false);
  reloadPlanData$ = this.reloadPlanDataSubject.asObservable();

  reloadPlanData() {
    this.reloadPlanDataSubject.next(true);
  }
}
